
import {initWebComponent} from "@/helpers/web-component-helper";
import {WizardComponent} from "@/components/wizard/wizard-component";
import {WizardNavItemComponent} from "@/components/wizard/wizard-nav-item-component";
import {FormTextareaComponent} from "@/components/form/form-textarea-component";
import {FormGeoLocationComponent} from "@/components/form/form-geo-location-component";
import {FormDomainListSingleComponent} from "@/components/form/form-domain-list-single-component";
import {FormTextComponent} from "@/components/form/form-text-component";
import {FormPreviewComponent} from "@/components/form/form-preview-component";
import {FormDateComponent} from "@/components/form/form-date-component";
import {FormFileUploadComponent} from "@/components/form/form-file-upload-component";
import {FormDomainListItemComponent} from "@/components/form/form-domain-list-item-component";
import {FormComponent} from "@/components/form/form-component";
import {FormHiddenComponent} from "@/components/form/form-hidden-component";
import {FormCheckboxComponent} from "@/components/form/form-checkbox-component";
import {checkDependentFields} from "@/helpers/form-dependent-helper";

const template = document.createElement('template');

window.wizardItem = []
export class WizardBodyComponent extends HTMLElement {
    constructor() {
        super();
        const key = parseInt(this.getAttribute('data-key'))

        let innerHtml = ``

        const wizardItem = window.wizard.Items[key]

        window.domainListItems = []

        wizardItem.Items.map((item, wizardItemKey) => {
            window.wizardItem[wizardItemKey] = item
            innerHtml += '<form-element data-form-attribute-id="' + item.FormAttributeID + '" data-default-value="' + item.DefaultValue +'" data-attribute-type-id="' + item.AttributeTypeID + '" data-key="' + wizardItemKey  + '" data-id="' + item.AttributeID + '"></form-element>'
        })

        template.innerHTML = innerHtml

        initWebComponent(this, template)
    }
}

window.customElements.define("form-element", FormComponent);

window.customElements.define("form-textarea", FormTextareaComponent);
window.customElements.define("form-geo-location", FormGeoLocationComponent);
window.customElements.define("form-domain-list-single", FormDomainListSingleComponent);
window.customElements.define("form-domain-list-item", FormDomainListItemComponent);
window.customElements.define("form-text", FormTextComponent);
window.customElements.define("form-hidden", FormHiddenComponent);
window.customElements.define("form-preview", FormPreviewComponent);
window.customElements.define("form-date", FormDateComponent);
window.customElements.define("form-file-upload", FormFileUploadComponent);
window.customElements.define("form-checkbox", FormCheckboxComponent);
